import { getQuantityMapFromStorage } from '@digital-retail/store-manager';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import BodyCopy from '../ui/BodyCopy/BodyCopy';
import ShippingDetailsStyles from './ShippingDetails.style';

const isNonEmptyString = (str) => {
  return typeof str === 'string' && str.trim().length > 0;
};

const ShippingDetails = ({ availabilityLabels, expressDeliveryLimit, variant }) => {
  const [quantitiesMap, setQuantitiesMap] = useState(new Map());

  useEffect(() => {
    setQuantitiesMap(getQuantityMapFromStorage());
  }, []);

  const qty = quantitiesMap.get(variant)?.quantity ?? 0;

  let { pickUpFromStoreShipping, homeDeliveryShipping, expressShipping } = availabilityLabels;
  if (expressDeliveryLimit > 0) {
    if (
      qty > expressDeliveryLimit &&
      (isNonEmptyString(homeDeliveryShipping) || isNonEmptyString(pickUpFromStoreShipping))
    ) {
      expressShipping = '';
    } else {
      homeDeliveryShipping = '';
      pickUpFromStoreShipping = '';
    }
  }
  return (
    <ul className="shipping-details">
      {expressShipping && (
        <li className="shipping-wrapper">
          <span className="express-icon" />
          <BodyCopy size="copy4">
            {(cl) => <span dangerouslySetInnerHTML={{ __html: expressShipping }} className={`${cl}`} />}
          </BodyCopy>
        </li>
      )}
      {homeDeliveryShipping && (
        <li className="shipping-wrapper">
          <span className="scheduled-icon" />
          <BodyCopy size="copy4">{(cl) => <span className={`${cl}`}>{homeDeliveryShipping}</span>}</BodyCopy>
        </li>
      )}
      {pickUpFromStoreShipping && (
        <li className="shipping-wrapper">
          <span className="store-icon" />
          <BodyCopy size="copy4">{(cl) => <span className={`${cl}`}>{pickUpFromStoreShipping}</span>}</BodyCopy>
        </li>
      )}
      <style jsx>{ShippingDetailsStyles}</style>
    </ul>
  );
};

ShippingDetails.propTypes = {
  availabilityLabels: PropTypes.shape({
    homeDeliveryShipping: PropTypes.string,
    pickUpFromStoreShipping: PropTypes.string,
    expressShipping: PropTypes.string,
  }),
  expressDeliveryLimit: PropTypes.number,
  variant: PropTypes.string,
};

ShippingDetails.defaultProps = {
  availabilityLabels: {},
  expressDeliveryLimit: 0,
  variant: '',
};

export { ShippingDetails };
